import * as React from 'react';

const TextBlock = ({ text }) => (
  <React.Fragment>
    {text.split(/\n/g).map((t: string, i: number) => (
      <React.Fragment key={i}>
        {t}
        <br />
      </React.Fragment>
    ))}
  </React.Fragment>
);

export default TextBlock;
